/**
 * Conversational form mode API client (F6)
 *
 * These two endpoints live on the SITE controller
 * (`site/src/Controller/ConversationController.php`) and are reachable by
 * anonymous visitors, so they go through the public form's own proxy exactly
 * like `formSubmission.submitForm`. The controller token is the class name with
 * a lowercased first letter: `conversation`.
 *
 * Nothing here is stored server-side. The values come back to the browser, the
 * browser puts them in the ordinary form state, and the submission still goes
 * through the normal endpoint with the normal validation and CAPTCHA.
 */

import {apiClient} from './api-client';
import type {AiConversationStart, AiConversationTurn} from '../types/ai-features.types';

export const conversationService = {
  /** Open a conversation and read the budget this respondent has. */
  start(formId: number): Promise<AiConversationStart> {
    return apiClient.callProxy<AiConversationStart>('conversation', 'startConversation', {formId});
  },

  /** Read one free text answer into one field's value. */
  answer(formId: number, fieldName: string, answer: string): Promise<AiConversationTurn> {
    return apiClient.callProxy<AiConversationTurn>('conversation', 'answerTurn', {
      formId,
      fieldName,
      answer,
    });
  },
};

export default conversationService;
